import axiosInsAcademy from '@/api/axios-ugems-academy';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {
  // Get all courses for Mitra Enrollment Report
  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/unenrollment/courses-hse', { params });
  },

  // Get course detail - using course-catalog API
  getCourseDetail(id) {
    return GET_COURSE_BY_ID(id);
  },

  // Get batches for approval
  getBatchesApproval(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/unenrollment/courses/${courseId}/batches-hse`, { params });
  },

  // Approve participants for a batch
  approveParticipants(batchId, data) {
    return axiosInsAcademy.post(`/tna/partner/unenrollment/training-event/${batchId}/approve`, data);
  },

  // Reject participants for a batch
  rejectParticipants(batchId, data) {
    return axiosInsAcademy.post(`/tna/partner/unenrollment/training-event/${batchId}/reject`, data);
  },

  // Get TNA summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/hse/summary', { params });
  }
};
